<template>
    <div class="saleCWrap">
      <div class="saleTit">销量排行榜</div>
      <!-- 销售列表 -->
      <ul class="saleList">
        <li class="flex-row jus-b" v-for="item in arr">
          <img src="../../../assets/goods.jpg" alt="">
          <div class="info flex-col jus-b">
            <p class="tit">森锐（ESALEB）CI011 森锐随身厅三合一多功能读写卡设备森锐随身厅三合一多功能读写卡设备</p>
            <p class="saleNum">销量：1233</p>
          </div>
        </li>
      </ul>
    </div>
</template>

<script>
    export default {
        name: "saleList",
        data() {
          return {
            arr: [1,2,3,4,5]
          }
        },
    }
</script>

<style scoped>
  .saleCWrap{
    width: 326px;
    height: 544px;
    padding:0 9px;
    background: #fff;
  }
  .saleCWrap .saleTit{
    height: 46px;
    line-height: 46px;
    font-weight: bold;
    font-size: 15px;
    color:#2B2727;
  }
  .saleList{
    width: 320px;
  }
  .saleList li{
    padding:12px 15px 12px 15px;
    cursor: pointer;
  }
  .saleList li+li{
    margin-top: 1px;
  }
  .saleList li img{
    width: 72px;
    height: 72px;
  }
  .saleList li .info{
    width: 200px;
    height: 72px;
  }
  .saleList li .info .tit{
      color:#333;
      font-size: 13px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /* autoprefixer: off */ -webkit-box-orient: vertical; /* autoprefixer: on */
  }
  .saleList li .info .saleNum{
    color:#C5C5C5;
    font-size: 12px;
  }
  .saleList li:nth-child(1),.saleList li:nth-child(2),.saleList li:nth-child(3){
    position: relative;
  }
  .saleList li:nth-child(1):after,.saleList li:nth-child(2):after,.saleList li:nth-child(3):after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 55px;
    height: 54px;
    background: url("../../../assets/no1.png") no-repeat;
    background-size: 100% 100%;
  }
  .saleList li:nth-child(2):after{
    background-image: url("../../../assets/no2.png");
  }
  .saleList li:nth-child(3):after{
    background-image: url("../../../assets/no3.png");
  }
</style>
